import {FunctionComponent, TableHTMLAttributes} from 'react';
import {TableRow} from '@/components/table/table-body/row/row';
import {TableTheme} from '@/constants/table';
import TableBodyRow from './row';

type BodyProps = TableHTMLAttributes<HTMLTableCellElement> & {
  rows: TableRow[];
  theme: TableTheme;
};

const TableBody: FunctionComponent<BodyProps> = ({rows, theme}) => {
  return (
    <tbody>
      {rows.map((row, rowIndex) => (
        <TableBodyRow row={row} theme={theme} key={rowIndex} />
      ))}
    </tbody>
  );
};

export default TableBody;
